$(function(){
   // Date picker options
   var range_picker_opts = {
    start: "year",
    depth: "year",
    format: "MM/yyyy"
  };

  // initialize date picker component
  var element_from = $(".daterangepicker-from")
    .kendoDatePicker(range_picker_opts)
    .attr('readonly','readonly')
    .data("kendoDatePicker");

  var element_to = $(".daterangepicker-to")
    .kendoDatePicker(range_picker_opts)
    .attr('readonly','readonly')
    .data("kendoDatePicker");

  // constrain range
  if (element_from && element_to) {
    function setMinMax() {
      if (element_to.value() != null) {
        element_from.max(element_to.value());
      }

      if (element_from.value()  != null) {
        element_to.min(element_from.value());
      }
    }

    element_from.bind("change", setMinMax);
    element_to.bind("change", setMinMax);

    setMinMax(); 
  }
});